/**
 * Status de cotação ligados ao pedido parcial (CLUB-1443).
 *
 * Sem dependências do Vue nem de `@/`: é importado direto pelos testes de
 * tests/unit (node --test).
 */

// tbl_cotacao.cot_status: já há pedidos, mas a digitação segue aberta para o
// que ainda não foi pedido.
export const PARTIAL_ORDER_STATUS = 16;
export const PARTIAL_ORDER_STATUS_NAME = 'PEDIDO PARCIAL';

// Fechada com pedido (o "PEDIDO GERADO" de sempre).
export const ORDER_CREATED_STATUS = 4;
export const ORDER_CREATED_STATUS_NAME = 'PEDIDO GERADO';

/** Aceita o código (16, "16") ou o nome do status. */
export function is_partial_order_status(status) {
    if (status === null || status === undefined || status === '') return false;
    if (Number(status) === PARTIAL_ORDER_STATUS) return true;
    return String(status).trim().toUpperCase() === PARTIAL_ORDER_STATUS_NAME;
}

/**
 * Nome do status de uma linha do monitor (`{ status, status_nome }`).
 *
 * O código manda: o getcotacoes do legado ainda não conhece o 16 e o devolve
 * como "CANCELADA" (ou sem nome), e o cache `q_statuses` pode ser anterior ao
 * status existir.
 */
export function request_status_name(item) {
    if (!item) return '';
    if (is_partial_order_status(item.status)) return PARTIAL_ORDER_STATUS_NAME;
    return item.status_nome || '';
}

/** Nome do status a partir do `cot_status` devolvido pelo kyojin. */
export function status_name_for(cot_status) {
    if (is_partial_order_status(cot_status)) return PARTIAL_ORDER_STATUS_NAME;
    if (Number(cot_status) === ORDER_CREATED_STATUS) return ORDER_CREATED_STATUS_NAME;
    return null;
}

/**
 * Mensagem de erro dos endpoints de pedido parcial do kyojin:
 * `{ errors: [msg] }` (422 de regra), `{ message, errors: { campo: [msg] } }`
 * (validação do Laravel) ou o `{ mensagem }` do legado.
 */
export function order_error_message(error, fallback = 'Não foi possível realizar o pedido.') {
    if (error && error.code === 'ECONNABORTED') {
        return 'O pedido está demorando mais que o esperado. Confira a aba Pedidos antes de tentar novamente, para evitar pedidos duplicados.';
    }

    const data = error && error.response ? error.response.data : null;

    if (!data) return fallback;
    if (typeof data === 'string') return data.trim() || fallback;

    const errors = data.errors;

    if (Array.isArray(errors) && errors.length) return String(errors[0]);

    if (errors && typeof errors === 'object') {
        const first = Object.values(errors)[0];
        if (Array.isArray(first) && first.length) return String(first[0]);
        if (typeof first === 'string' && first) return first;
    }

    return data.message || data.mensagem || data.error || fallback;
}

/**
 * 422 é recusa de regra ("nada pendente nesta seleção", "não aceita mais
 * pedidos"): a tela avisa em vez de tratar como falha.
 */
export function is_rule_rejection(error) {
    return !!(error && error.response && error.response.status === 422);
}
